export default "__VITE_ASSET__iGQ8DTqn__"